import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CharterImg from "../assets/images/Yacht.png";
import ComingSoon from "../assets/images/comingsoon.png"


export const CharterBooking = ({ name, price }) => {
    const [animatedElements, setAnimatedElements] = useState([]);

    useEffect(() => {
        // Function to check if an element is in the viewport
        const isInViewport = (elem) => {
            const bounding = elem.getBoundingClientRect();
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        };

        // Function to handle scroll event
        const handleScroll = () => {
            const elements = document.querySelectorAll('.col-lg-6');
            elements.forEach((el) => {
                if (isInViewport(el) && !animatedElements.includes(el)) {
                    setAnimatedElements((prev) => [...prev, el]);
                }
            });
        };

        // Add event listener for scroll event
        window.addEventListener('scroll', handleScroll);
        
        // Clean up event listener
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [animatedElements]);

    return (
         <div className="CharterBoxArae">
            <div className="container">
                <div className="row">
                    <div className={`col-lg-6 ${animatedElements.includes(0) ? "slide-in-left" : ""}`}>
                        <div className="CharterBox">
                            <img src={CharterImg} alt="Charter" />
                            <div className="chartercontent">
                                <h2>Luxury Charters{name}</h2>
                                <div className="bookingprice">
                                    <p className="chartprice">$ 2000-2300 {price}</p>
                                    <p className="bookinghrs">4 Hours</p>
                                </div>
                                <Link to="/Booking">
                                    <button>Book Now</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className={`col-lg-6 ${animatedElements.includes(0) ? "slide-in-left" : ""}`}>
                        <div className="CharterBox">
                            <img src={CharterImg} alt="Charter" />
                            <div className="chartercontent">
                                <h2>Luxury Charters {name}</h2>
                                <div className="bookingprice">
                                    <p className="chartprice">$ 2700-3000 {price}</p>
                                    <p className="bookinghrs">6 Hours</p>
                                </div>
                                <Link to="/Booking">
                                    <button>Book Now</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    {/* Repeat for other col-lg-6 elements */}
                </div>
                <div className="row">
                    <div className={`col-lg-6 ${animatedElements.includes(0) ? "slide-in-left" : ""}`}>
                        <div className="CharterBox">
                            <img src={CharterImg} alt="Charter" />
                            <div className="chartercontent">
                                <h2>Luxury Charters {name}</h2>
                                <div className="bookingprice">
                                    <p className="chartprice">$ 3200-3500 {price}</p>
                                    <p className="bookinghrs">8 Hours</p>
                                </div>
                                <Link to="/Booking">
                                    <button>Book Now</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div id="rel" className={`col-lg-6 ${animatedElements.includes(0) ? "slide-in-left" : ""}`}>
                        <h1 id="comingsoon">Coming Soon</h1>
                        <div className="CharterBox" id="ComingSoonblur">
                            <img src={CharterImg} alt="Charter" />
                            <div className="chartercontent">
                                <h2>Extended Charters  {name}</h2>
                                <div className="bookingprice">
                                    <p className="chartprice">$ 2000-2300 {price}</p>
                                    <p className="bookinghrs">4 Hours</p>
                                </div>
                                {/* <Link to="#">
                                    <button>Book Now</button>
                                </Link> */}
                            </div>
                        </div>
                    </div>
                    {/* Repeat for other col-lg-6 elements */}
                </div>
            </div>
        </div>
    );
};

export default CharterBooking;
